import React,{ Component } from 'react';

import WebHeaderHome from './components/Common/WebHeaderHome.js';
import WebTrendings from './components/Trendings/WebTrendings.js';
import WebStoreBlocks from './components/Stores/WebStoreBlocks.js';
import WebFooter from './components/Common/WebFooter.js';
import WebCategories from './components/Common/WebCategories.js';
import WebBrandStoreBlocks from './components/Stores/WebBrandStoreBlocks.js';
import WebPromotions from './components/Promotions/WebPromotions.js';
import WebRecommended from './components/Promotions/WebRecommended';
import WebAdAssist from './components/Common/WebAdAssist';
import $ from 'jquery';

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets = 'https://aquadeals.in/admin/assets/';

export default class Web_App extends Component{
  constructor(props){
    super(props);
    this.dashBoard=this.dashBoard.bind(this);
  }

	componentDidMount()
	{
		if(screen.width < 800)
       {
         window.location.href="/home";
       }
        localStorage.removeItem('w_r_s_dt');
	    localStorage.removeItem('w_r_s_dt');
	    localStorage.removeItem('w_r_e_coupon_dt');
	    localStorage.removeItem('w_r_e_s_dt');
	    localStorage.removeItem('web_mycart');
	    localStorage.removeItem('w_r_enq_seller_page');
	    localStorage.removeItem('w_r_p_dt');
	    localStorage.removeItem('w_r_e_p_dt');
	    localStorage.removeItem('web_ofr_page');
	    localStorage.removeItem('profile');
	    localStorage.removeItem('myaquacash');
	    localStorage.removeItem('web_share_earn');
	    localStorage.removeItem('checkout');
	    localStorage.removeItem('order_details');
	    localStorage.removeItem('myorders');
	    localStorage.removeItem('w_r_p_deals');
	    localStorage.removeItem('seed');
	    localStorage.removeItem('nauplii');
	    localStorage.removeItem('subdeals');
	    localStorage.removeItem('shipping');
	    localStorage.removeItem('notifications');
	    localStorage.removeItem('web_quickcart');
	    localStorage.removeItem('view_rating');
	    localStorage.removeItem('w_modal_seed');
	    localStorage.removeItem('w_r_seed_deals');
	    localStorage.removeItem('w_r_e_p_dt');
	    localStorage.removeItem('w_modal_details');
	    localStorage.removeItem('offers');
	    localStorage.removeItem('give_rating');
	    localStorage.removeItem('pprice');
	    localStorage.removeItem('sprice');
	    localStorage.removeItem('seed_id');
	    localStorage.removeItem('h_type');
	    localStorage.removeItem('web_pro_ofr_dtls');
	    localStorage.removeItem('web_wishlist');
	    localStorage.removeItem('web_brand_details');

	    localStorage.removeItem('m_r_s_dt');
	    localStorage.removeItem('m_r_e_coupon_dt');
	    localStorage.removeItem('m_r_e_s_dt');
	    localStorage.removeItem('mob_mycart');
	    localStorage.removeItem('m_r_enq_seller_page');
	    localStorage.removeItem('m_r_p_dt');
	    localStorage.removeItem('m_r_e_p_dt');
	    localStorage.removeItem('ofr_page');
	    localStorage.removeItem('pro_ofr_dtls');

	    localStorage.removeItem('share_earn');
	    localStorage.removeItem('my_orders');
	    localStorage.removeItem('m_r_p_deals');
	    localStorage.removeItem('mob_quickcart');
	    localStorage.removeItem('partner_deals');

	    localStorage.removeItem('brand');
		localStorage.removeItem('d_type');
		localStorage.removeItem('Tid');
		localStorage.removeItem('type');
	    
	    if(localStorage.user_id && localStorage.token)
	    {
	      this.dashBoard();
	    }		
	}
  	dashBoard()
  	{
  	    var data1={from: 'desktop_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token')};
  	    var data2=JSON.stringify(data1);
  	    $.ajax({
  	          method: 'POST',
  	          url: baseUrl+'dashboard',
  	          dataType:'json',
  	          data: {req:data2},
  	          success: function(data)
  	          {
  	          }.bind(this),
  	          error: function(err)
  	          {
  	          
  	          }
  	    });
  	}	
	render()
	{
		document.title ="Online AquaCulture MarketPlace, Find best deals on Seed, Feed, Health Care, Machinery & Farm Equipments, Products, Ropes & Nets Paddle Wheels and More | AquaDeals";
	    document.getElementsByTagName("META")[2].content="It is a place for deals related to Aqua culture";
		return(
			<div>
				<WebHeaderHome />
				<WebTrendings />
				<WebStoreBlocks />
				<WebBrandStoreBlocks />
				<WebCategories />
                <WebAdAssist />
				<WebRecommended />
				<WebPromotions />
				<WebFooter />
			</div>
		)
	}
}


/** WEBPACK FOOTER **
 ** ./src/Desktop/Web_App.js
 **/